import { defineComponent as a, useCssModule as l, openBlock as c, createElementBlock as m, normalizeClass as e, unref as o, createElementVNode as s, createVNode as i, renderSlot as d, toDisplayString as p } from "vue";
import f from "../icon/comps/error-stroke.vue.mjs";
const u = "cdr-form-error", _ = "cdr-form-error__icon", S = /* @__PURE__ */ a({
  name: "CdrFormError",
  __name: "CdrFormError",
  props: {
    error: [Boolean, String]
  },
  setup(n) {
    const r = l();
    return (t, C) => (c(), m("div", {
      class: e(o(r)[u]),
      role: "status"
    }, [s("span", {
      class: e(o(r)[_])
    }, [i(f, {
      size: "small",
      "inherit-color": ""
    })], 2), d(t.$slots, "error", {}, () => [s("span", null, p(n.error), 1)])], 2));
  }
});
export {
  S as default
};
